/* Restyles the Simple Bundles Tonies builder to the NBS pack layout.
   Selection, pack changes, and add to cart stay on the app controls. */
(function (root) {
  'use strict';

  var COLOURS = [
    ['pink', '#f4b4c8'],
    ['teal', '#3eb6ae'],
    ['grey', '#cfd2d6'],
    ['gray', '#cfd2d6'],
    ['red', '#ef4d4d'],
    ['blue', '#7eb6e8'],
    ['yellow', '#f0d36b'],
    ['green', '#7dcea0'],
    ['purple', '#c3b0e0'],
    ['white', '#f7f7f7']
  ];

  function priceMarkup(cents) {
    var amount = Number(cents);
    if (!isFinite(amount)) return '';
    var sign = amount < 0 ? '-' : '';
    amount = Math.abs(Math.round(amount));
    var pounds = Math.floor(amount / 100);
    var pence = String(amount % 100).padStart(2, '0');
    var shown = sign + '£' + pounds + '.' + pence;
    return '<span class="price__raised"><span class="price__sr">' + shown + '</span><span class="price__visual" aria-hidden="true">' + sign + '£' + pounds + '<sup>.' + pence + '</sup></span></span>';
  }

  function setBundlePrice(cents, compareCents) {
    var price = doc.querySelector('[data-byob-nbs-price]');
    if (price) price.innerHTML = priceMarkup(cents);
    var compare = doc.querySelector('[data-byob-nbs-compare]');
    var compareAmount = Number(compareCents);
    var priceAmount = Number(cents);
    var showCompare = !!(compare && isFinite(compareAmount) && isFinite(priceAmount) && compareAmount > priceAmount);
    if (!compare) return;
    compare.hidden = !showCompare;
    compare.innerHTML = showCompare ? priceMarkup(compareAmount) : '';
    var wrap = compare.closest('[data-product-price-wrap]');
    if (wrap) wrap.hidden = !showCompare;
  }

  function money(cents) {
    var amount = Number(cents);
    if (!isFinite(amount)) return '';
    var sign = amount < 0 ? '-' : '';
    amount = Math.abs(Math.round(amount));
    return sign + '£' + Math.floor(amount / 100) + '.' + String(amount % 100).padStart(2, '0');
  }

  function saveLabel(priceCents, compareCents) {
    var diff = Number(compareCents) - Number(priceCents);
    if (!(diff > 0)) return '';
    return 'Save ' + money(diff);
  }

  function colourFromTitle(title) {
    var text = String(title || '').toLowerCase();
    var tail = text.match(/[-–]\s*([a-z]+)\s*$/);
    var source = tail ? tail[1] : text;
    for (var i = 0; i < COLOURS.length; i++) {
      var name = COLOURS[i][0];
      if (tail) {
        if (source === name) return COLOURS[i][1];
      } else if (new RegExp('\\b' + name + '\\b').test(source)) {
        return COLOURS[i][1];
      }
    }
    return '#d9dce3';
  }

  function brandBundle() {
    return !!(doc && doc.querySelector && doc.querySelector('.product-section.byob-nbs--nbs'));
  }

  function packHeadline(label) {
    if (brandBundle()) return String(label || 'Your bundle');
    var match = String(label || '').match(/(\d+)/);
    if (!match) return 'Your bundle';
    var count = Number(match[1]);
    return count + ' character' + (count === 1 ? '' : 's') + ' + starter set!';
  }

  function sharpSrc(src) {
    var value = String(src || '');
    if (!value) return '';
    if (/[?&]width=\d+/i.test(value)) return value.replace(/([?&])width=\d+/gi, '$1width=2000');
    if (value.indexOf('/cdn/shop/') === -1 && value.indexOf('cdn.shopify.com') === -1) return value;
    return value + (value.indexOf('?') === -1 ? '?width=2000' : '&width=2000');
  }

  function largestSrc(src, srcset) {
    var best = src || '';
    var bestW = 0;
    function consider(url, width) {
      if (!url) return;
      var size = width || 0;
      var match = String(url).match(/[?&]width=(\d+)/i);
      if (!size && match) size = Number(match[1]);
      if (!best || size >= bestW) {
        best = url;
        bestW = size;
      }
    }
    consider(best, 0);
    String(srcset || '').split(',').forEach(function (part) {
      var bits = part.trim().split(/\s+/);
      if (bits[0]) consider(bits[0], parseInt(bits[1], 10) || 0);
    });
    return sharpSrc(best);
  }

  function pageWindow(total, page, size) {
    var pages = Math.max(1, Math.ceil((total || 0) / size) || 1);
    var current = Math.min(Math.max(page || 1, 1), pages);
    return {
      pages: pages,
      current: current,
      start: (current - 1) * size,
      end: current * size
    };
  }

  function pageLabel(current, pages) {
    return String(current) + ' / ' + String(pages);
  }

  function pickMoreLabel(left) {
    var count = Number(left);
    if (!(count > 0)) return '';
    if (brandBundle()) {
      if (count === 1) return 'Pick 1 more';
      return 'Pick ' + count + ' more';
    }
    if (count === 1) return 'Pick 1 more Tonie to complete your bundle';
    return 'Pick ' + count + ' more Tonies to complete your bundle';
  }

  /* Pack rules live on script[data-byob-rules]. When a pack has no
     groupRange rules, the pack item-count is one choice from each
     section except the character list, which takes the remainder.
     That keeps an empty slot on the next product instead of the
     last step. */
  function sectionCaps(sectionNames, rules, packLabel, itemCount) {
    var names = (sectionNames || []).map(function (name) {
      return String(name || '').trim();
    });
    var caps = [];
    var assigned = 0;
    var open = [];
    for (var i = 0; i < names.length; i++) {
      var max = sectionLimit(rules, names[i], '');
      caps[i] = max;
      if (max) assigned += max;
      else open.push(i);
    }
    var count = Number(itemCount);
    if (isFinite(count) && count > 0 && open.length) {
      var remaining = count - assigned;
      var flexible = open[open.length - 1];
      for (var j = 0; j < open.length; j++) {
        if (/character/i.test(names[open[j]])) {
          flexible = open[j];
          break;
        }
      }
      var fixed = [];
      for (var k = 0; k < open.length; k++) {
        if (open[k] !== flexible) fixed.push(open[k]);
      }
      if (remaining > fixed.length || (open.length === 1 && remaining > 0)) {
        for (var f = 0; f < fixed.length; f++) caps[fixed[f]] = 1;
        caps[flexible] = remaining - fixed.length;
        return caps;
      }
    }
    var labelCount = 0;
    var labelMatch = String(packLabel || '').match(/(\d+)\s+tonies/i);
    if (labelMatch) labelCount = Number(labelMatch[1]);
    for (var n = 0; n < open.length; n++) {
      var sectionName = names[open[n]] || '';
      if (caps[open[n]]) continue;
      if (labelCount && /character/i.test(sectionName)) caps[open[n]] = labelCount;
      else if (!/character/i.test(sectionName)) caps[open[n]] = 1;
    }
    return caps;
  }

  function sectionLimit(rules, sectionName, packLabel) {
    var name = String(sectionName || '').trim();
    var list = rules || [];
    for (var i = 0; i < list.length; i++) {
      var rule = list[i];
      if (!rule || rule.type !== 'groupRange') continue;
      if (String(rule.section || '') !== name) continue;
      var max = Number(rule.max);
      if (isFinite(max) && max > 0) return max;
    }
    var match = String(packLabel || '').match(/(\d+)\s+tonies/i);
    if (match && /character/i.test(name)) return Number(match[1]);
    return 0;
  }

  var api = {
    money: money,
    saveLabel: saveLabel,
    colourFromTitle: colourFromTitle,
    packHeadline: packHeadline,
    pageWindow: pageWindow,
    pageLabel: pageLabel,
    pickMoreLabel: pickMoreLabel,
    sectionLimit: sectionLimit,
    sectionCaps: sectionCaps,
    sharpSrc: sharpSrc,
    largestSrc: largestSrc
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  }

  if (!root.document) return;

  var doc = root.document;
  var panelState = {};
  var sawIncomplete = false;
  var scrolledToCheckout = false;
  var slideCartOpened = false;
  var slideCartPending = false;
  var slideIndex = 0;
  var colourSlide = null;
  var applying = false;
  var lastPackId = null;
  var clearingPack = false;

  function bundle() {
    return doc.getElementById('byob-app-embed-wrapper');
  }

  function section(name) {
    var widget = bundle();
    if (!widget) return null;
    var sections = widget.querySelectorAll('.byob-bundle__product-section');
    for (var i = 0; i < sections.length; i++) {
      var label = sections[i].getAttribute('aria-label') || '';
      if (label.indexOf(name) !== -1) return sections[i];
    }
    return null;
  }

  function packs() {
    var widget = bundle();
    if (!widget) return [];
    return Array.prototype.slice.call(widget.querySelectorAll('byob-pack[slot="options"]'));
  }

  function activePack() {
    var list = packs();
    for (var i = 0; i < list.length; i++) {
      var link = list[i].querySelector('a.byob-option');
      if (list[i].hasAttribute('active') || (link && link.getAttribute('aria-current') === 'page')) {
        return list[i];
      }
    }
    return list[0] || null;
  }

  function showText(node, text) {
    if (!node) return;
    if (!text) {
      node.hidden = true;
      node.textContent = '';
      return;
    }
    node.hidden = false;
    if (node.textContent !== text) node.textContent = text;
  }

  function ensure(parent, selector, tag, className) {
    var node = parent.querySelector(selector);
    if (node) return node;
    node = doc.createElement(tag);
    node.className = className;
    parent.appendChild(node);
    return node;
  }

  function wrapLayout() {
    var product = doc.querySelector('.product-section.byob-nbs');
    var widget = bundle();
    if (!product || !widget) return null;
    var layout = product.querySelector('.byob-nbs-layout') || doc.querySelector('.byob-nbs-layout');
    if (!layout) {
      layout = doc.createElement('div');
      layout.className = 'byob-nbs-layout';
      var slot = doc.createElement('div');
      slot.className = 'byob-nbs-gallery-slot';
      var buy = doc.createElement('div');
      buy.className = 'byob-nbs-buy';
      layout.appendChild(slot);
      layout.appendChild(buy);
      product.parentNode.insertBefore(layout, product);
    }
    var slot = layout.querySelector('.byob-nbs-gallery-slot');
    var buy = layout.querySelector('.byob-nbs-buy');
    var gallery = (slot && slot.querySelector('.byob-product-image')) || layout.querySelector('.byob-product-image') || product.querySelector('.byob-product-image');
    var header = (buy && buy.querySelector('.product-single__header')) || product.querySelector('.product-single__header');
    var trust = (buy && buy.querySelector('[data-byob-nbs-trust]')) || product.querySelector('[data-byob-nbs-trust]');
    if (gallery && slot && gallery.parentNode !== slot) slot.appendChild(gallery);
    if (header && buy && !buy.contains(header)) buy.insertBefore(header, buy.firstChild);
    if (buy && header && buy.contains(header) && widget.previousElementSibling !== header) header.insertAdjacentElement('afterend', widget);
    else if (buy && widget.parentNode !== buy) buy.appendChild(widget);
    if (trust && buy && trust.parentNode !== buy) buy.appendChild(trust);
    return layout;
  }

  function slides() {
    var node = doc.querySelector('[data-byob-nbs-slides]');
    if (!node) return [];
    try {
      return JSON.parse(node.textContent) || [];
    } catch (err) {
      return [];
    }
  }

  function showSlide() {
    var photo = doc.querySelector('[data-byob-nbs-photo]');
    var index = doc.querySelector('[data-byob-nbs-index]');
    var gallery = colourSlide ? [colourSlide].concat(slides()) : slides();
    if (!photo || !gallery.length) return;
    if (slideIndex >= gallery.length) slideIndex = 0;
    if (slideIndex < 0) slideIndex = gallery.length - 1;
    var item = gallery[slideIndex];
    var src = sharpSrc(item.src);
    photo.removeAttribute('srcset');
    if (photo.getAttribute('src') !== src) photo.setAttribute('src', src);
    photo.alt = item.alt || '';
    if (index) index.textContent = String(slideIndex + 1);
  }

  function bindGallery() {
    var stage = doc.querySelector('[data-byob-nbs-stage]');
    if (!stage || stage.dataset.nbsBound) return;
    stage.dataset.nbsBound = 'true';
    var prev = stage.querySelector('[data-byob-nbs-prev]');
    var next = stage.querySelector('[data-byob-nbs-next]');
    if (prev) prev.addEventListener('click', function () { slideIndex -= 1; showSlide(); });
    if (next) next.addEventListener('click', function () { slideIndex += 1; showSlide(); });
    showSlide();
  }

  function decoratePacks() {
    var widget = bundle();
    if (!widget) return;
    var row = widget.querySelector('.byob-mini-cart__pack-row');
    var singlePack = brandBundle() && packs().length < 2;
    if (singlePack && row) {
      row.hidden = true;
      var packStep = row.previousElementSibling;
      if (packStep && packStep.classList.contains('byob-nbs-step--pack')) packStep.hidden = true;
    }
    if (!singlePack && row && !(row.previousElementSibling && row.previousElementSibling.classList.contains('byob-nbs-step'))) {
      var step = doc.createElement('div');
      step.className = 'byob-nbs-step byob-nbs-step--pack';
      step.innerHTML = '<span class="byob-nbs-stepnum">1</span> Choose your pack';
      row.parentNode.insertBefore(step, row);
    }
    packs().forEach(function (pack) {
      var link = pack.querySelector('a.byob-option');
      if (!link) return;
      var label = pack.getAttribute('label') || '';
      var price = pack.getAttribute('price-cents');
      var compare = pack.getAttribute('compare-at-price-cents');
      var popular = /4\s+tonies/i.test(label);
      if (!link.querySelector('.byob-nbs-radio') || link.dataset.nbsPack !== label + ':' + price) {
        link.dataset.nbsPack = label + ':' + price;
        link.innerHTML =
          '<span class="byob-nbs-radio" aria-hidden="true"></span>' +
          '<span class="byob-nbs-pack-copy"><span class="byob-nbs-pack-name"></span><span class="byob-nbs-pack-save"></span></span>' +
          '<span class="byob-nbs-pack-price"></span>';
      }
      link.querySelector('.byob-nbs-pack-name').textContent = label;
      var save = link.querySelector('.byob-nbs-pack-save');
      var saveText = saveLabel(price, compare);
      save.hidden = !saveText;
      save.textContent = saveText;
      link.querySelector('.byob-nbs-pack-price').textContent = money(price);
      var badge = pack.querySelector('.byob-nbs-popular');
      if (popular && !badge) {
        badge = doc.createElement('span');
        badge.className = 'byob-nbs-popular';
        badge.textContent = 'MOST POPULAR';
        pack.appendChild(badge);
      } else if (!popular && badge) {
        badge.remove();
      }
    });

    var pack = activePack();
    if (!pack) return;
    var saveText = saveLabel(pack.getAttribute('price-cents'), pack.getAttribute('compare-at-price-cents'));
    setBundlePrice(pack.getAttribute('price-cents'), pack.getAttribute('compare-at-price-cents'));
    showText(doc.querySelector('[data-byob-nbs-save-pill]'), saveText ? 'You save ' + saveText.replace('Save ', '') : '');
    showText(doc.querySelector('[data-byob-nbs-save]'), saveText);
    var packId = pack ? pack.getAttribute('variant-id') : '';
    if (!lastPackId && packId) lastPackId = packId;
    syncSku();
  }

  function syncSku() {
    var data = doc.querySelector('[data-variant-json]');
    if (!data) return;
    var variants;
    try { variants = JSON.parse(data.textContent); } catch (err) { return; }
    var pack = activePack();
    var id = pack && String(pack.getAttribute('variant-id') || '');
    var match = null;
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === id) { match = variants[i]; break; }
    }
    var sku = match && match.sku;
    if (!sku) return;
    var nodes = doc.querySelectorAll('.product-section.byob-nbs [data-sku-id]');
    Array.prototype.forEach.call(nodes, function (node) {
      node.textContent = sku;
      var wrap = node.closest('[data-sku]');
      if (!wrap) return;
      wrap.hidden = false;
      wrap.classList.remove('hide');
    });
  }

  function isStarWidget(node) {
    if (!node || node.closest('[data-byob-nbs-reviews]')) return false;
    var id = node.getAttribute && node.getAttribute('data-yotpo-instance-id');
    if (id === '457898') return false;
    if (id === '457899') return true;
    if (node.classList && (node.classList.contains('bottomLine') || node.classList.contains('yotpo-bottomline'))) return true;
    return !!(node.classList && node.classList.contains('yotpo-widget-instance') && node.getAttribute('data-yotpo-product-id') && id !== '457898');
  }

  function mountReviews() {
    var slot = doc.querySelector('[data-byob-nbs-reviews]');
    if (!slot) return;
    if (slot.querySelector('.yotpo-widget-instance, .yotpo.bottomLine, .yotpo-bottomline')) return;
    var nodes = doc.querySelectorAll('.yotpo-widget-instance, .yotpo.bottomLine, .yotpo-bottomline');
    var star = null;
    for (var i = 0; i < nodes.length; i++) {
      if (isStarWidget(nodes[i])) { star = nodes[i]; break; }
    }
    if (!star) return;
    var block = star.closest('.shopify-block, .product-block') || star;
    if (slot.contains(block)) return;
    slot.appendChild(block);
    if (slot.dataset.nbsYotpoInit) return;
    var yotpo = root.yotpoWidgetsContainer;
    if (!yotpo || typeof yotpo.initWidgets !== 'function') return;
    slot.dataset.nbsYotpoInit = '1';
    try { yotpo.initWidgets(); } catch (err) { /* stars stay hidden if Yotpo never arrives */ }
  }

  function clearSelections() {
    if (clearingPack) return;
    var widget = bundle();
    if (!widget) return;
    clearingPack = true;
    var removes = widget.querySelectorAll('.byob-resource__remove');
    Array.prototype.forEach.call(removes, function (button) { button.click(); });
    productSections().forEach(function (panel) {
      cardsIn(panel).forEach(function (card) {
        var guard = 0;
        while (cardQuantity(card) > 0 && guard < 8) {
          var less = card.querySelector('.byob-stepper__btn[aria-label="Decrease quantity"]');
          if (!less) break;
          less.click();
          guard += 1;
        }
      });
    });
    colourSlide = null;
    slideIndex = 0;
    sawIncomplete = false;
    scrolledToCheckout = false;
    showSlide();
    clearingPack = false;
  }

  function onPackChange() {
    var pack = activePack();
    var id = pack ? pack.getAttribute('variant-id') : '';
    if (lastPackId && id && id !== lastPackId) clearSelections();
    lastPackId = id || lastPackId;
    syncSku();
  }

  function productSections() {
    var widget = bundle();
    if (!widget) return [];
    return Array.prototype.slice.call(widget.querySelectorAll('.byob-bundle__product-section'));
  }

  function sectionKey(panel, index) {
    return panel.getAttribute('aria-label') || ('section-' + index);
  }

  function stateFor(key) {
    if (!panelState[key]) panelState[key] = { page: 1, query: '' };
    return panelState[key];
  }

  function rulesForPack(packId) {
    if (!packId) return [];
    var node = doc.querySelector('script[data-byob-rules][data-pack-variant-id="' + packId + '"]');
    if (!node) return [];
    try {
      var data = JSON.parse(node.textContent);
      return (data && data.rules) || [];
    } catch (err) {
      return [];
    }
  }

  function sectionMax(panel) {
    var pack = activePack();
    var rules = rulesForPack(pack && pack.getAttribute('variant-id'));
    var sections = productSections();
    var caps = sectionCaps(
      sections.map(function (section) { return section.getAttribute('aria-label') || ''; }),
      rules,
      pack && pack.getAttribute('label'),
      pack && pack.getAttribute('item-count')
    );
    var index = sections.indexOf(panel);
    if (index >= 0 && caps[index]) return caps[index];
    var fromRules = sectionLimit(rules, panel.getAttribute('aria-label') || '', pack && pack.getAttribute('label'));
    if (fromRules) return fromRules;
    var count = panel.querySelector('.byob-bundle__product-section-count');
    var text = count ? count.textContent : '';
    var match = text.match(/of\s+(\d+)/i);
    return match ? Number(match[1]) : 0;
  }

  function cardsIn(panel) {
    if (!panel) return [];
    return Array.prototype.slice.call(panel.querySelectorAll('.byob-bundle__product-card'));
  }

  function looksLikeColours(panel) {
    var cards = cardsIn(panel);
    if (!cards.length) return false;
    var coloured = 0;
    cards.forEach(function (card) {
      if (colourFromTitle(cardTitle(card)) !== '#d9dce3') coloured += 1;
    });
    return coloured >= Math.ceil(cards.length / 2);
  }

  function boxPanel() {
    var named = section('Toniebox') || section('Colour') || section('Color');
    if (named) return named;
    var sections = productSections();
    for (var i = 0; i < sections.length; i++) {
      if (looksLikeColours(sections[i])) return sections[i];
    }
    return sections[0] || null;
  }

  function boxCards() {
    return cardsIn(boxPanel());
  }

  function cardTitle(card) {
    var node = card.querySelector('.byob-bundle__product-card-title-text');
    return node ? node.textContent.trim() : '';
  }

  function cardPicked(card) {
    if (card.querySelector('.byob-stepper')) return true;
    var title = cardTitle(card);
    var widget = bundle();
    if (!title || !widget) return false;
    var rows = widget.querySelectorAll('.byob-mini-cart__list .byob-resource:not(.byob-resource--placeholder)');
    for (var i = 0; i < rows.length; i++) {
      var name = rows[i].querySelector('.byob-resource__title');
      var text = name ? (name.dataset.nbsOriginal || name.textContent) : '';
      if (text && text.indexOf(title) !== -1) return true;
    }
    return false;
  }

  function syncColours() {
    var host = doc.querySelector('[data-byob-nbs-colours]');
    var cards = boxCards();
    if (!host) return;
    var signature = cards.map(function (card) {
      return cardTitle(card) + (cardPicked(card) ? '*' : '');
    }).join('|');
    if (host.dataset.signature !== signature) {
      host.dataset.signature = signature;
      host.innerHTML = '';
      cards.forEach(function (card, index) {
        var title = cardTitle(card);
        var button = doc.createElement('button');
        button.type = 'button';
        button.className = 'byob-nbs-colour';
        button.style.setProperty('--swatch', colourFromTitle(title));
        button.setAttribute('aria-label', title);
        button.setAttribute('aria-pressed', cardPicked(card) ? 'true' : 'false');
        button.addEventListener('click', function () {
          chooseBox(card);
        });
        host.appendChild(button);
        if (cardPicked(card)) showPickedImage(card);
        button.dataset.index = String(index);
      });
    } else {
      var buttons = host.querySelectorAll('.byob-nbs-colour');
      cards.forEach(function (card, index) {
        if (buttons[index]) buttons[index].setAttribute('aria-pressed', cardPicked(card) ? 'true' : 'false');
      });
    }
  }

  function celebrate(card) {
    if (!card) return;
    var media = card.querySelector('.byob-bundle__product-card-media') || card;
    media.classList.remove('is-spinning');
    void media.offsetWidth;
    media.classList.add('is-spinning');
    root.setTimeout(function () {
      media.classList.remove('is-spinning');
    }, 700);
    var title = cardTitle(card);
    root.setTimeout(function () {
      var widget = bundle();
      if (!widget || !title) return;
      var rows = widget.querySelectorAll('.byob-mini-cart__list .byob-resource:not(.byob-resource--placeholder)');
      Array.prototype.forEach.call(rows, function (row) {
        var name = row.querySelector('.byob-resource__title');
        var text = name ? (name.dataset.nbsOriginal || name.textContent) : '';
        if (text && text.indexOf(title) !== -1) {
          row.classList.add('is-just-added');
          root.setTimeout(function () { row.classList.remove('is-just-added'); }, 900);
        }
      });
    }, 160);
  }

  function showPickedImage(card) {
    var image = card && card.querySelector('.byob-bundle__product-card-img');
    if (!image) return;
    var src = largestSrc(image.getAttribute('src'), image.getAttribute('srcset'));
    if (!src) return;
    colourSlide = { src: src, alt: cardTitle(card) };
    slideIndex = 0;
    showSlide();
  }

  function findBundleProduct(card) {
    var title = cardTitle(card);
    if (!title) return null;
    var panel = card.closest('.byob-bundle__product-section');
    var sectionName = panel ? (panel.getAttribute('aria-label') || '') : '';
    var active = activePack();
    var activeId = active ? active.getAttribute('variant-id') : '';
    var products = doc.querySelectorAll('byob-product');
    for (var i = 0; i < products.length; i++) {
      if ((products[i].getAttribute('product-title') || '') !== title) continue;
      var section = products[i].closest('byob-section');
      if (sectionName && section && section.getAttribute('section-title') !== sectionName) continue;
      var packId = section && section.getAttribute('data-pack-variant-id');
      if (activeId && packId && packId !== activeId) continue;
      return products[i];
    }
    return null;
  }

  function variantsFromProduct(product, title) {
    if (!product) return [];
    return Array.prototype.map.call(product.querySelectorAll(':scope > byob-variant, byob-variant'), function (node) {
      if (node.parentElement !== product && node.parentElement && node.parentElement.parentElement !== product) return null;
      return {
        id: node.getAttribute('variant-id') || '',
        label: node.getAttribute('option-values') || '',
        price: node.getAttribute('price-cents'),
        available: node.getAttribute('available') !== 'false',
        image: node.getAttribute('image-url') || product.getAttribute('image-url') || '',
        title: node.getAttribute('product-title') || title || ''
      };
    }).filter(function (item) { return item && item.id; });
  }

  function variantsForCard(card) {
    return variantsFromProduct(findBundleProduct(card), cardTitle(card));
  }

  /* A sold-out size can be missing from the bundle markup even though
     the product still has it. Ask Shopify for that product's variants
     and show the missing unavailable sizes. An in-stock size that the
     bundle does offer keeps its own available flag. */
  function withCatalogSizes(product, variants) {
    var url = product && product.getAttribute('product-url');
    if (!url) return Promise.resolve(variants.slice());
    var path = String(url).split('?')[0];
    if (!path) return Promise.resolve(variants.slice());
    return fetch(path + '.js', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('catalog');
        return response.json();
      })
      .then(function (data) {
        var byId = {};
        variants.forEach(function (item) { byId[String(item.id)] = item; });
        var ordered = [];
        var seen = {};
        (data.variants || []).forEach(function (variant) {
          var id = String(variant.id);
          var existing = byId[id];
          if (existing) {
            if (variant.available === false) existing.available = false;
            ordered.push(existing);
            seen[id] = true;
            return;
          }
          if (variant.available) return;
          var label = variant.title && variant.title !== 'Default Title' ? variant.title : (variant.option1 || '');
          if (!label) return;
          ordered.push({
            id: id,
            label: label,
            price: variant.price,
            available: false,
            image: product.getAttribute('image-url') || '',
            title: data.title || product.getAttribute('product-title') || ''
          });
          seen[id] = true;
        });
        variants.forEach(function (item) {
          if (!seen[String(item.id)]) ordered.push(item);
        });
        return ordered;
      })
      .catch(function () { return variants.slice(); });
  }

  function selectVariantOnCard(card, variant) {
    if (!card || !variant) return;
    var picker = card.querySelector('byob-product-picker-card');
    if (picker && typeof picker.onOptionChange === 'function') {
      try { picker.onOptionChange(0, variant.id); } catch (err) { /* the select below still sets it */ }
    }
    var selects = card.querySelectorAll('.byob-bundle__product-variant-select');
    if (!selects.length && picker && picker.shadowRoot) {
      selects = picker.shadowRoot.querySelectorAll('.byob-bundle__product-variant-select');
    }
    var wanted = String(variant.label || '');
    Array.prototype.forEach.call(selects, function (select) {
      var match = Array.prototype.find.call(select.options, function (option) {
        return option.value === wanted || option.textContent.trim() === wanted || wanted.indexOf(option.value) !== -1;
      });
      if (!match) return;
      select.value = match.value;
      select.dispatchEvent(new Event('input', { bubbles: true }));
      select.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function clickAdd(card) {
    var add = card.querySelector('.byob-cta--add');
    if (add) {
      add.click();
      return true;
    }
    var picker = card.querySelector('byob-product-picker-card');
    if (picker && typeof picker.onAddClick === 'function') {
      picker.onAddClick();
      return true;
    }
    return false;
  }

  function finishAdd(card, panel) {
    if (panel && panel.classList.contains('byob-nbs-picker--single')) {
      chooseBox(card);
      return;
    }
    var less = card.querySelector('.byob-stepper__btn[aria-label="Decrease quantity"]');
    if (less) less.click();
    else if (clickAdd(card)) {
      showPickedImage(card);
      celebrate(card);
      queueReveal(panel);
    }
  }

  function cardFullyUnavailable(card) {
    var variants = variantsForCard(card);
    if (!variants.length) return false;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].available) return false;
    }
    return true;
  }

  function markUnavailableCard(card) {
    var blocked = brandBundle() && cardFullyUnavailable(card);
    card.classList.toggle('is-unavailable', blocked);
    if (blocked) card.setAttribute('aria-disabled', 'true');
    else card.removeAttribute('aria-disabled');
    var buttons = card.querySelectorAll('button, a');
    Array.prototype.forEach.call(buttons, function (button) {
      if (blocked) button.setAttribute('aria-disabled', 'true');
      else if (button.getAttribute('aria-disabled') === 'true' && button.dataset.nbsDisabled === '1') {
        button.removeAttribute('aria-disabled');
      }
      if (blocked) button.dataset.nbsDisabled = '1';
      else delete button.dataset.nbsDisabled;
    });
    var meta = card.querySelector('.byob-bundle__product-card-meta');
    var tag = card.querySelector('.byob-nbs-oos');
    if (!blocked) {
      if (tag) tag.remove();
      return;
    }
    if (!tag) {
      tag = doc.createElement('p');
      tag.className = 'byob-nbs-oos';
      tag.textContent = 'Out of stock';
    }
    var title = meta && meta.querySelector(':scope > .byob-bundle__product-card-title');
    var lead = meta && meta.querySelector(':scope > [data-byob-lead]');
    if (lead) lead.insertAdjacentElement('beforebegin', tag);
    else if (title) title.insertAdjacentElement('afterend', tag);
    else if (meta) meta.insertBefore(tag, meta.firstChild);
    else card.appendChild(tag);
  }

  function requestAdd(card, panel) {
    if (card && card.classList.contains('is-unavailable')) return;
    var variants = variantsForCard(card);
    if (variants.length > 1) {
      openSizeSheet(card, panel, variants);
      return;
    }
    if (variants.length === 1) {
      if (!variants[0].available) return;
      selectVariantOnCard(card, variants[0]);
    }
    finishAdd(card, panel);
  }

  var sizeSheetState = null;

  function sizeSheetFocusable(dialog) {
    return Array.prototype.filter.call(dialog.querySelectorAll('button, [href], input, select, textarea'), function (el) {
      return !el.disabled && !el.hidden;
    });
  }

  function closeSizeSheet() {
    var sheet = doc.querySelector('.byob-nbs-size');
    if (!sheet || sheet.hidden) return;
    sheet.hidden = true;
    doc.body.classList.remove('byob-nbs-size-open');
    var back = sizeSheetState && sizeSheetState.focus;
    sizeSheetState = null;
    if (back && typeof back.focus === 'function') back.focus();
  }

  function openSizeSheet(card, panel, variants) {
    var sheet = doc.querySelector('.byob-nbs-size');
    if (!sheet) {
      sheet = doc.createElement('div');
      sheet.className = 'byob-nbs-size';
      sheet.hidden = true;
      sheet.innerHTML = '<div class="byob-nbs-size__backdrop" data-byob-size-close></div><div class="byob-nbs-size__dialog" role="dialog" aria-modal="true" aria-labelledby="byob-nbs-size-title"><button type="button" class="byob-nbs-size__close" data-byob-size-close aria-label="Close"><span aria-hidden="true">&times;</span></button><img class="byob-nbs-size__image" alt=""><div class="byob-nbs-size__copy"><h2 id="byob-nbs-size-title"></h2><p class="byob-nbs-size__price"></p></div><div class="byob-nbs-size__options" role="listbox" aria-label="Size"></div></div>';
      doc.body.appendChild(sheet);
      sheet.addEventListener('click', function (event) {
        if (event.target.closest('[data-byob-size-close]')) closeSizeSheet();
      });
      sheet.addEventListener('keydown', function (event) {
        if (sheet.hidden) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          closeSizeSheet();
          return;
        }
        if (event.key !== 'Tab') return;
        var dialog = sheet.querySelector('.byob-nbs-size__dialog');
        var items = sizeSheetFocusable(dialog);
        if (!items.length) return;
        var first = items[0];
        var last = items[items.length - 1];
        if (event.shiftKey && doc.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && doc.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
    }
    var image = card.querySelector('.byob-bundle__product-card-img');
    var photo = sheet.querySelector('.byob-nbs-size__image');
    var title = sheet.querySelector('#byob-nbs-size-title');
    title.textContent = cardTitle(card);
    photo.src = largestSrc(image && image.getAttribute('src'), image && image.getAttribute('srcset')) || (variants[0] && variants[0].image) || '';
    photo.alt = '';
    renderSizeChoices(sheet, card, panel, variants);
    var token = {};
    sizeSheetState = { focus: doc.activeElement, token: token };
    sheet.hidden = false;
    doc.body.classList.add('byob-nbs-size-open');
    focusSizeChoice(sheet);
    var product = findBundleProduct(card);
    var shown = variants.map(function (item) {
      return String(item.id) + ':' + (item.available ? '1' : '0');
    }).join('|');
    withCatalogSizes(product, variants).then(function (items) {
      if (!sizeSheetState || sizeSheetState.token !== token || sheet.hidden) return;
      var next = items.map(function (item) {
        return String(item.id) + ':' + (item.available ? '1' : '0');
      }).join('|');
      if (next === shown) return;
      renderSizeChoices(sheet, card, panel, items);
      focusSizeChoice(sheet);
    });
  }

  function focusSizeChoice(sheet) {
    var dialog = sheet.querySelector('.byob-nbs-size__dialog');
    var focus = sizeSheetFocusable(dialog).filter(function (el) {
      return el.classList.contains('byob-nbs-size__option') && !el.disabled;
    })[0] || sheet.querySelector('.byob-nbs-size__close');
    if (focus) focus.focus();
  }

  function renderSizeChoices(sheet, card, panel, variants) {
    var price = sheet.querySelector('.byob-nbs-size__price');
    var list = sheet.querySelector('.byob-nbs-size__options');
    var firstAvailable = null;
    variants.forEach(function (item) {
      if (!firstAvailable && item.available) firstAvailable = item;
    });
    if (price) price.textContent = firstAvailable ? money(firstAvailable.price) : '';
    if (!list) return;
    list.innerHTML = '';
    variants.forEach(function (item) {
      var button = doc.createElement('button');
      button.type = 'button';
      button.className = 'byob-nbs-size__option';
      button.setAttribute('role', 'option');
      button.setAttribute('aria-selected', 'false');
      var name = doc.createElement('span');
      name.textContent = item.label || 'One size';
      var meta = doc.createElement('span');
      meta.textContent = item.available ? money(item.price) : 'Sold out';
      button.appendChild(name);
      button.appendChild(meta);
      if (!item.available) {
        button.disabled = true;
        button.classList.add('is-sold-out');
      } else {
        button.addEventListener('click', function () {
          selectVariantOnCard(card, item);
          closeSizeSheet();
          finishAdd(card, panel);
        });
      }
      list.appendChild(button);
    });
  }

  function chooseBox(card) {
    if (cardPicked(card)) return;
    celebrate(card);
    showPickedImage(card);
    var panel = card.closest('.byob-bundle__product-section') || boxPanel();
    cardsIn(panel).forEach(function (other) {
      if (other !== card && cardPicked(other)) {
        var remove = removeButtonFor(other);
        if (remove) remove.click();
      }
    });
    root.setTimeout(function () {
      clickAdd(card);
      queueReveal(panel);
    }, 60);
  }

  function removeButtonFor(card) {
    var title = cardTitle(card);
    var widget = bundle();
    if (!widget || !title) return null;
    var rows = widget.querySelectorAll('.byob-mini-cart__list .byob-resource:not(.byob-resource--placeholder)');
    for (var i = 0; i < rows.length; i++) {
      var name = rows[i].querySelector('.byob-resource__title');
      var original = name ? (name.dataset.nbsOriginal || name.textContent) : '';
      if (original && original.indexOf(title) !== -1) {
        return rows[i].querySelector('.byob-resource__remove');
      }
    }
    return null;
  }

  function setSlotHint(row, hint) {
    var tag = row.querySelector('.byob-nbs-included-tag');
    if (!hint) {
      if (tag) tag.remove();
      return;
    }
    if (!tag) {
      tag = doc.createElement('div');
      tag.className = 'byob-nbs-included-tag';
      var title = row.querySelector('.byob-resource__title');
      if (title) title.insertAdjacentElement('afterend', tag);
      else row.appendChild(tag);
    }
    if (tag.textContent !== hint) tag.textContent = hint;
  }

  function missingSlots() {
    var slots = [];
    productSections().forEach(function (panel) {
      var max = sectionMax(panel);
      var picked = sectionPicked(panel);
      var name = (panel.getAttribute('aria-label') || '').trim();
      for (var n = picked; n < max; n++) {
        slots.push({
          section: name,
          title: max > 1 ? 'Your pick ' + (n + 1) : name,
          hint: max > 1 ? '' : (looksLikeColours(panel) || /colour|color|toniebox|headphone|backpack/i.test(name) ? 'Choose a colour' : 'Choose')
        });
      }
    });
    return slots;
  }

  function panelForSlot(row) {
    var name = row && row.dataset ? row.dataset.nbsSection || '' : '';
    if (!name) return null;
    var sections = productSections();
    for (var i = 0; i < sections.length; i++) {
      var panel = sections[i];
      if ((panel.getAttribute('aria-label') || '').trim() !== name) continue;
      var max = sectionMax(panel);
      if (max > 0 && sectionPicked(panel) < max) return panel;
    }
    return null;
  }

  function decorateSummary() {
    var widget = bundle();
    if (!widget) return;
    var list = widget.querySelector('.byob-mini-cart__list');
    if (!list) return;
    var head = list.querySelector('.byob-nbs-bundle-head');
    if (!head) {
      head = doc.createElement('div');
      head.className = 'byob-nbs-bundle-head';
      head.innerHTML = '<span>Your bundle</span><span data-byob-nbs-bundle-count></span>';
      list.insertBefore(head, list.firstChild);
    }
    var pack = activePack();
    var count = head.querySelector('[data-byob-nbs-bundle-count]');
    if (count) count.textContent = packHeadline(pack ? pack.getAttribute('label') : '');

    var rows = list.querySelectorAll('.byob-resource');
    var slots = missingSlots();
    var slotIndex = 0;
    Array.prototype.forEach.call(rows, function (row) {
      var title = row.querySelector('.byob-resource__title');
      if (!title) return;
      var original = title.dataset.nbsOriginal || title.textContent;
      var isBox = /toniebox|starter set/i.test(original);
      if (!row.classList.contains('byob-resource--placeholder')) {
        var chosen = row.querySelector('.byob-resource__variant');
        if (chosen) {
          var chosenLabel = chosen.textContent.replace(/\s+/g, ' ').trim();
          chosen.hidden = !chosenLabel || /^default title$/i.test(chosenLabel);
        }
      }
      if (!row.classList.contains('byob-resource--placeholder') && isBox) {
        if (!title.dataset.nbsOriginal) title.dataset.nbsOriginal = title.textContent.trim();
        if (title.textContent !== 'Toniebox 2 + Creative Tonie') title.textContent = 'Toniebox 2 + Creative Tonie';
        if (!row.querySelector('.byob-nbs-included-tag')) {
          var tag = doc.createElement('div');
          tag.className = 'byob-nbs-included-tag';
          tag.textContent = 'Included';
          title.insertAdjacentElement('afterend', tag);
        }
        return;
      }
      if (!row.classList.contains('byob-resource--placeholder')) return;
      var variant = row.querySelector('.byob-resource__variant');
      if (variant) variant.hidden = true;
      var slot = slots[slotIndex] || null;
      slotIndex += 1;
      var nextTitle = slot && slot.title ? slot.title : 'Add a product';
      if (title.textContent !== nextTitle) title.textContent = nextTitle;
      row.dataset.nbsSection = slot ? slot.section : '';
      setSlotHint(row, slot ? slot.hint : '');
    });

    if (!list.querySelector('.byob-nbs-bundle-note')) {
      var note = doc.createElement('p');
      note.className = 'byob-nbs-bundle-note';
      note.textContent = brandBundle() ? 'Tap a choice to add it to your bundle' : 'Tap your favourite Tonies to complete your bundle';
      list.appendChild(note);
    }
    bindEmptySlots(list);
  }

  function bindEmptySlots(list) {
    var slots = list.querySelectorAll('.byob-resource--placeholder');
    Array.prototype.forEach.call(slots, function (row) {
      var title = row.querySelector('.byob-resource__title');
      var label = title ? title.textContent.trim() : 'Add a product';
      row.setAttribute('role', 'button');
      row.tabIndex = 0;
      row.setAttribute('aria-hidden', 'false');
      if (row.getAttribute('aria-label') !== label) row.setAttribute('aria-label', label);
      if (row.dataset.nbsJump) return;
      row.dataset.nbsJump = '1';
      var jump = function (event) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }
        var panel = panelForSlot(row) || nextOpenPicker();
        if (panel) revealPicker(panel);
      };
      row.addEventListener('click', jump);
      row.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        jump();
      });
    });
  }

  function shortChoice(title) {
    var tail = String(title || '').match(/[-–]\s*([A-Za-z]+)\s*$/);
    if (!tail) return title;
    return tail[1].charAt(0).toUpperCase() + tail[1].slice(1);
  }

  function pickerTitle(panel) {
    var label = (panel.getAttribute('aria-label') || '').trim();
    if (/character/i.test(label)) return 'Choose your Tonies';
    if (/toniebox|colour|color|\bbox\b/i.test(label)) return 'Choose your box';
    var existing = panel.querySelector('.byob-bundle__product-section-title');
    return (existing && existing.textContent.trim()) || label || 'Choose';
  }

  function searchPlaceholder(panel) {
    var label = (panel.getAttribute('aria-label') || '').toLowerCase();
    if (label.indexOf('character') !== -1) return "Search characters, eg 'Bluey'";
    if (label.indexOf('audiobook') !== -1) return 'Search audiobooks';
    if (/toniebox|colour|color|\bbox\b/.test(label) || looksLikeColours(panel)) return 'Search colours';
    return 'Search';
  }

  function ensurePickerHeader(panel, step) {
    var header = panel.querySelector('.byob-bundle__product-section-header');
    if (!header) {
      header = doc.createElement('div');
      header.className = 'byob-bundle__product-section-header';
      var heading = doc.createElement('h3');
      heading.className = 'byob-bundle__product-section-title';
      header.appendChild(heading);
      panel.insertBefore(header, panel.firstChild);
    }
    if (!header.querySelector('.byob-nbs-stepnum')) {
      var badge = doc.createElement('span');
      badge.className = 'byob-nbs-stepnum';
      header.insertBefore(badge, header.firstChild);
    }
    header.querySelector('.byob-nbs-stepnum').textContent = String(step);
    var title = panel.querySelector('.byob-bundle__product-section-title');
    var nextTitle = pickerTitle(panel);
    if (title && title.textContent !== nextTitle) title.textContent = nextTitle;
    var count = panel.querySelector('.byob-bundle__product-section-count');
    if (count) count.textContent = count.textContent.replace('selected', 'picked');
    return count;
  }

  function decoratePicker(panel, index, stepBase) {
    var key = sectionKey(panel, index);
    var state = stateFor(key);
    var exclusive = sectionMax(panel) === 1 || (sectionMax(panel) === 0 && looksLikeColours(panel));
    var characters = /character/i.test(panel.getAttribute('aria-label') || '');
    panel.classList.add('byob-nbs-picker');
    panel.classList.toggle('byob-nbs-picker--single', exclusive);
    panel.classList.toggle('byob-nbs-picker--characters', characters);
    var count = ensurePickerHeader(panel, index + (stepBase || 2));
    var max = sectionMax(panel);
    var picked = sectionPicked(panel);
    if (count && max) count.textContent = picked + ' of ' + max + ' picked';

    if (!panel.querySelector('.byob-nbs-search')) {
      var search = doc.createElement('label');
      search.className = 'byob-nbs-search';
      search.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="6" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="M16 16l4 4" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg><input type="search">';
      var grid = panel.querySelector('.byob-bundle__product-grid');
      if (grid) panel.insertBefore(search, grid);
      else panel.appendChild(search);
      search.querySelector('input').addEventListener('input', function (event) {
        state.query = event.target.value.trim().toLowerCase();
        apply();
      });
    }
    var searchInput = panel.querySelector('.byob-nbs-search input');
    if (searchInput) {
      var placeholder = searchPlaceholder(panel);
      if (searchInput.getAttribute('placeholder') !== placeholder) {
        searchInput.setAttribute('placeholder', placeholder);
        searchInput.setAttribute('aria-label', placeholder);
      }
      if (searchInput.value !== state.query) searchInput.value = state.query;
    }

    var cards = panel.querySelectorAll('.byob-bundle__product-card');
    var matched = [];
    Array.prototype.forEach.call(cards, function (card) {
      var title = cardTitle(card).toLowerCase();
      var visible = !state.query || title.indexOf(state.query) !== -1;
      card.dataset.searchHidden = visible ? '' : 'true';
      card.classList.toggle('is-picked', cardPicked(card));
      markUnavailableCard(card);
      if (visible) matched.push(card);
      if (!card.dataset.nbsClick) {
        card.dataset.nbsClick = 'true';
        card.addEventListener('click', function (event) {
          if (card.classList.contains('is-unavailable')) {
            event.preventDefault();
            event.stopPropagation();
            return;
          }
          var adding = event.target.closest('.byob-cta--add');
          var choose = event.target.closest('.byob-cta');
          var inModal = choose && choose.closest('.byob-options-modal');
          if (choose && !inModal && variantsForCard(card).length > 1) {
            event.preventDefault();
            event.stopPropagation();
            requestAdd(card, panel);
            return;
          }
          if (event.target.closest('.byob-cta, .byob-stepper, a, select, button')) {
            if (adding && !panel.classList.contains('byob-nbs-picker--single')) showPickedImage(card);
            return;
          }
          event.preventDefault();
          event.stopPropagation();
          if (panel.classList.contains('byob-nbs-picker--single') && cardPicked(card)) {
            var remove = removeButtonFor(card);
            if (remove) remove.click();
            return;
          }
          requestAdd(card, panel);
        }, true);
      }
    });

    Array.prototype.forEach.call(cards, function (card) {
      card.hidden = card.dataset.searchHidden === 'true';
    });
    lazyCardImages(panel);

    var empty = panel.querySelector('.byob-nbs-empty');
    if (!matched.length) {
      if (!empty) {
        empty = doc.createElement('p');
        empty.className = 'byob-nbs-empty';
        panel.appendChild(empty);
      }
      empty.hidden = false;
      empty.textContent = 'Nothing matches that search.';
    } else if (empty) {
      empty.hidden = true;
    }

    var pager = panel.querySelector('.byob-nbs-pager');
    if (pager) pager.remove();

    var hint = panel.querySelector('.byob-nbs-hint');
    if (!hint) {
      hint = doc.createElement('p');
      hint.className = 'byob-nbs-hint';
      panel.appendChild(hint);
    }
    var pickedCard = null;
    cardsIn(panel).forEach(function (card) {
      if (cardPicked(card)) pickedCard = card;
    });
    panel.classList.remove('is-collapsed');

    var header = panel.querySelector('.byob-bundle__product-section-header');
    var chosen = header && header.querySelector('.byob-nbs-chosen');
    var toggle = header && header.querySelector('.byob-nbs-picker-toggle');
    if (toggle) toggle.remove();
    if (exclusive && header) {
      if (!chosen) {
        chosen = doc.createElement('span');
        chosen.className = 'byob-nbs-chosen';
        header.appendChild(chosen);
      }
      chosen.hidden = !pickedCard;
      chosen.textContent = pickedCard ? shortChoice(cardTitle(pickedCard)) : '';
    } else if (chosen) {
      chosen.remove();
    }

    if (!exclusive && max) {
      var left = max - picked;
      var more = pickMoreLabel(left);
      hint.hidden = !more;
      hint.textContent = more;
    } else if (exclusive) {
      hint.hidden = !!pickedCard;
      hint.textContent = 'Choose one to include in your bundle';
    } else {
      hint.hidden = true;
    }
  }

  function tightenGrid(panel) {
    var grid = panel.querySelector('.byob-bundle__product-grid');
    if (!grid) return;
    var wide = root.matchMedia && root.matchMedia('(min-width: 769px)').matches;
    grid.style.setProperty('row-gap', '8px', 'important');
    grid.style.setProperty('column-gap', '10px', 'important');
    grid.style.setProperty('gap', '8px 10px', 'important');
    grid.style.setProperty('grid-template-columns', wide ? 'repeat(5, minmax(0, 1fr))' : 'repeat(3, minmax(0, 1fr))', 'important');
    grid.style.setProperty('align-items', 'start', 'important');
    grid.style.setProperty('margin', '0', 'important');
  }

  function decoratePickers() {
    var stepBase = brandBundle() && packs().length < 2 ? 1 : 2;
    productSections().forEach(function (panel, index) {
      decoratePicker(panel, index, stepBase);
      tightenGrid(panel);
    });
  }

  function openSlideCart(attempt) {
    if (slideCartOpened) return;
    if (!attempt && slideCartPending) return;
    slideCartPending = true;
    var amp = root.AMP_API;
    if (amp && typeof amp.OPEN_CART === 'function') {
      slideCartOpened = true;
      try {
        var pending = amp.OPEN_CART();
        if (pending && typeof pending.catch === 'function') pending.catch(function () {});
      } catch (err) { /* the add already succeeded; the drawer can be opened from the bag icon */ }
      return;
    }
    if (typeof root.SLIDECART_OPEN === 'function') {
      slideCartOpened = true;
      try { root.SLIDECART_OPEN(); } catch (err) { /* fall through to the theme drawer */ }
      return;
    }
    if ((attempt || 0) < 8) {
      root.setTimeout(function () { openSlideCart((attempt || 0) + 1); }, 150);
      return;
    }
    slideCartOpened = true;
    doc.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true }));
    doc.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
  }

  function cartSectionId() {
    var section = doc.querySelector('.shopify-section[id^="shopify-section-"]');
    if (!section || !section.id) return '';
    return section.id.replace(/^shopify-section-/, '');
  }

  /* Simple Bundles posts /cart/add.js, then sends the shopper to /cart unless
     it finds a theme cart-drawer. This store uses the AMP slide cart, so a
     hidden drawer hook keeps the add and opens that cart instead. */
  function hookSlideCart() {
    if (doc.querySelector('cart-drawer, cart-notification')) return;
    try {
      var hook = doc.createElement('cart-drawer');
      hook.setAttribute('data-nbs-byob-cart', 'true');
      hook.hidden = true;
      hook.getSectionsToRender = function () {
        var id = cartSectionId();
        return id ? [{ id: id }] : [];
      };
      hook.renderContents = function () {
        openSlideCart();
      };
      (doc.body || doc.documentElement).appendChild(hook);
    } catch (err) { /* a real cart element already owns this tag */ }
  }

  function variantNodeForRow(row) {
    var titleEl = row.querySelector('.byob-resource__title');
    if (!titleEl) return null;
    var title = (titleEl.dataset && titleEl.dataset.nbsOriginal) || titleEl.textContent.replace(/\s+/g, ' ').trim();
    var optionEl = row.querySelector('.byob-resource__variant');
    var option = optionEl ? optionEl.textContent.replace(/\s+/g, ' ').trim() : '';
    if (/^default title$/i.test(option)) option = '';
    var nodes = doc.querySelectorAll('byob-variant');
    var fallback = null;
    var fallbackCount = 0;
    for (var i = 0; i < nodes.length; i++) {
      if ((nodes[i].getAttribute('product-title') || '') !== title) continue;
      var value = (nodes[i].getAttribute('option-values') || '').replace(/\s+/g, ' ').trim();
      if (option && value === option) return nodes[i];
      if (!option) {
        fallback = nodes[i];
        fallbackCount += 1;
      }
    }
    return !option && fallbackCount === 1 ? fallback : null;
  }

  function bundleHasUnavailableChoice(widget) {
    var rows = widget.querySelectorAll('.byob-resource:not(.byob-resource--placeholder)');
    for (var i = 0; i < rows.length; i++) {
      var node = variantNodeForRow(rows[i]);
      if (node && node.getAttribute('available') === 'false') return true;
    }
    return false;
  }

  function bindCheckout() {
    var widget = bundle();
    if (!widget || widget.dataset.nbsCheckout === '1') return;
    widget.dataset.nbsCheckout = '1';
    widget.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest('.byob-mini-cart__checkout');
      if (!button || button.disabled) return;
      if (bundleHasUnavailableChoice(widget)) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      slideCartOpened = false;
      slideCartPending = false;
    }, true);
  }

  function watchCartResult() {
    if (root.__nbsByobCartWatch) return;
    root.__nbsByobCartWatch = true;
    doc.addEventListener('simple-bundles-byob:add-to-cart:complete', function () {
      openSlideCart();
    });
  }

  function labelCheckout() {
    var widget = bundle();
    if (!widget) return;
    var button = widget.querySelector('.byob-mini-cart__checkout');
    if (!button) return;
    var inner = button.querySelector('.byob-btn-inner') || button;
    var added = button.classList.contains('byob-mini-cart__checkout--added');
    var label = added ? 'Added to bag' : 'Add bundle to bag';
    var node = Array.prototype.find.call(inner.childNodes, function (child) {
      return child.nodeType === 3 && child.textContent.trim();
    });
    if (!node) {
      inner.appendChild(doc.createTextNode(label));
    } else if (node.textContent !== label) {
      node.textContent = label;
    }
  }

  function cardQuantity(card) {
    var value = card.querySelector('.byob-stepper__value');
    if (value) {
      var qty = parseInt(value.textContent, 10);
      if (qty > 0) return qty;
    }
    return cardPicked(card) ? 1 : 0;
  }

  function sectionPicked(panel) {
    var total = 0;
    cardsIn(panel).forEach(function (card) {
      total += cardQuantity(card);
    });
    return total;
  }

  function nextOpenPicker() {
    return nextPickerAfter(null);
  }

  function nextPickerAfter(fromPanel) {
    var sections = productSections();
    var start = fromPanel ? sections.indexOf(fromPanel) + 1 : 0;
    if (start < 0) start = 0;
    for (var i = start; i < sections.length; i++) {
      var max = sectionMax(sections[i]);
      if (max > 0 && sectionPicked(sections[i]) < max) return sections[i];
    }
    return null;
  }

  /* Park the next picker just under the site header. The app's own
     scrollIntoView({block:'start'}) jumps the following section to the
     top of the page and hides it under the sticky header. */
  function reducedMotion() {
    return root.matchMedia && root.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function easeInOut(t) {
    return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
  }

  function scrollToY(target) {
    var top = Math.max(0, target);
    if (reducedMotion() || typeof root.requestAnimationFrame !== 'function') {
      root.scrollTo(0, top);
      return;
    }
    var start = root.scrollY || root.pageYOffset || 0;
    var distance = top - start;
    if (Math.abs(distance) < 2) return;
    var duration = 700;
    var started = null;
    function step(now) {
      if (started === null) started = now;
      var progress = Math.min(1, (now - started) / duration);
      root.scrollTo(0, start + distance * easeInOut(progress));
      if (progress < 1) root.requestAnimationFrame(step);
    }
    root.requestAnimationFrame(step);
  }

  function revealPicker(panel) {
    if (!panel || typeof root.scrollTo !== 'function') return;
    var header = panel.querySelector('.byob-bundle__product-section-header') || panel;
    var rect = header.getBoundingClientRect();
    var topGap = 120;
    var comfortableBottom = Math.min(root.innerHeight * 0.55, root.innerHeight - 180);
    if (rect.top >= topGap && rect.top <= comfortableBottom) return;
    var y = (root.scrollY || root.pageYOffset || 0) + rect.top - topGap;
    scrollToY(y);
  }

  function revealCheckout() {
    var widget = bundle();
    if (!widget || typeof root.scrollTo !== 'function') return;
    var button = widget.querySelector('.byob-mini-cart__checkout');
    if (!button) return;
    var rect = button.getBoundingClientRect();
    var topGap = 120;
    if (rect.top >= topGap && rect.bottom <= (root.innerHeight || 0) - 24) return;
    var y = (root.scrollY || root.pageYOffset || 0) + rect.top - topGap;
    scrollToY(y);
  }

  /* A finished step moves on. A step that still needs picks stays put,
     so a long character grid does not jump back to its header. */
  function revealAfterPick(fromPanel) {
    if (fromPanel) {
      var max = sectionMax(fromPanel);
      if (max > 0 && sectionPicked(fromPanel) < max) return;
    }
    var next = (fromPanel && nextPickerAfter(fromPanel)) || nextOpenPicker();
    if (next && next !== fromPanel) {
      revealPicker(next);
      return;
    }
    revealCheckout();
  }

  function lazyCardImages(panel) {
    var images = panel.querySelectorAll('.byob-bundle__product-card-img');
    Array.prototype.forEach.call(images, function (image, index) {
      var loading = index < 8 ? 'eager' : 'lazy';
      if (image.getAttribute('loading') !== loading) image.setAttribute('loading', loading);
      if (image.getAttribute('decoding') !== 'async') image.setAttribute('decoding', 'async');
    });
  }

  var revealTimer = null;
  function scheduleReveal(panel) {
    if (!panel) return;
    root.clearTimeout(revealTimer);
    revealTimer = root.setTimeout(function () {
      var max = sectionMax(panel);
      if (max > 0 && sectionPicked(panel) < max) {
        revealPicker(panel);
        return;
      }
      revealAfterPick(panel);
    }, reducedMotion() ? 0 : 800);
  }

  function queueReveal(fromPanel) {
    root.clearTimeout(revealTimer);
    revealTimer = root.setTimeout(function () {
      revealAfterPick(fromPanel);
    }, reducedMotion() ? 0 : 800);
  }

  function tameSectionScroll() {
    if (root.__nbsByobScrollTame || !root.Element) return;
    root.__nbsByobScrollTame = true;
    var original = root.Element.prototype.scrollIntoView;
    root.Element.prototype.scrollIntoView = function (options) {
      var sectionEl = this && this.classList && this.classList.contains('byob-bundle__product-section')
        ? this
        : (this && this.closest ? this.closest('.byob-bundle__product-section') : null);
      if (sectionEl && sectionEl.closest && sectionEl.closest('.product-section.byob-nbs')) {
        scheduleReveal(sectionEl);
        return;
      }
      return original.apply(this, arguments);
    };
  }

  function returnToCheckout() {
    if (slideCartOpened) return;
    var open = nextOpenPicker();
    if (open) {
      sawIncomplete = true;
      scrolledToCheckout = false;
      return;
    }
    var widget = bundle();
    if (!widget) return;
    var button = widget.querySelector('.byob-mini-cart__checkout');
    if (!button) return;
    var complete = !button.disabled && !button.classList.contains('byob-mini-cart__checkout--added');
    if (!complete) {
      sawIncomplete = true;
      scrolledToCheckout = false;
      return;
    }
    if (!sawIncomplete || scrolledToCheckout) return;
    scrolledToCheckout = true;
    var rect = button.getBoundingClientRect();
    var inView = rect.top >= 80 && rect.bottom <= root.innerHeight - 24;
    if (!inView) button.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function apply() {
    if (applying || !doc.querySelector('.product-section.byob-nbs')) return;
    applying = true;
    var widget = bundle();
    var observer = widget && widget._nbsObserver;
    if (observer) observer.disconnect();
    try {
      [wrapLayout, bindGallery, mountReviews, decoratePacks, syncColours, decorateSummary, decoratePickers, bindCheckout, labelCheckout, returnToCheckout].forEach(function (fn) {
        try { fn(); } catch (err) { /* one failed decoration should not stop the rest */ }
      });
    } finally {
      applying = false;
      if (observer && widget) observer.observe(widget, { childList: true, subtree: true });
    }
  }

  function watch() {
    var widget = bundle();
    if (!widget || widget._nbsObserver) return !!widget;
    var queued = false;
    var observer = new MutationObserver(function () {
      if (applying || queued) return;
      queued = true;
      root.requestAnimationFrame(function () {
        queued = false;
        apply();
      });
    });
    widget._nbsObserver = observer;
    observer.observe(widget, { childList: true, subtree: true });
    widget.addEventListener('byob-pack-select', function () {
      colourSlide = null;
      root.setTimeout(function () {
        onPackChange();
        apply();
      }, 60);
    });
    return true;
  }

  function tagEmptySlots(list) {
    var slots = missingSlots();
    var slotIndex = 0;
    Array.prototype.forEach.call(list.querySelectorAll('.byob-resource--placeholder'), function (row) {
      var slot = slots[slotIndex] || null;
      slotIndex += 1;
      row.dataset.nbsSection = slot ? slot.section : '';
    });
    bindEmptySlots(list);
  }

  function decorateClassic() {
    if (applying) return;
    var widget = bundle();
    if (!widget) return;
    applying = true;
    var observer = widget._nbsObserver;
    if (observer) observer.disconnect();
    try {
      var list = widget.querySelector('.byob-mini-cart__list');
      if (list) tagEmptySlots(list);
    } finally {
      applying = false;
      if (observer) observer.observe(widget, { childList: true, subtree: true });
    }
  }

  function watchClassic() {
    var widget = bundle();
    if (!widget || widget._nbsObserver) return !!widget;
    var queued = false;
    var observer = new MutationObserver(function () {
      if (applying || queued) return;
      queued = true;
      root.requestAnimationFrame(function () {
        queued = false;
        decorateClassic();
      });
    });
    widget._nbsObserver = observer;
    observer.observe(widget, { childList: true, subtree: true });
    return true;
  }

  function startClassic() {
    var kick = function () {
      if (watchClassic()) decorateClassic();
    };
    kick();
    doc.addEventListener('DOMContentLoaded', kick);
    root.setTimeout(kick, 0);
    root.setTimeout(kick, 250);
    root.setTimeout(kick, 1000);
  }

  function start() {
    if (doc.querySelector('.product-section.byob-classic') && !doc.querySelector('.product-section.byob-nbs')) {
      startClassic();
      return;
    }
    if (!doc.querySelector('.product-section.byob-nbs')) return;
    tameSectionScroll();
    hookSlideCart();
    watchCartResult();
    var kick = function () {
      bindGallery();
      if (watch()) apply();
    };
    kick();
    doc.addEventListener('DOMContentLoaded', kick);
    doc.addEventListener('shopify:section:load', kick);
    root.setTimeout(kick, 0);
    root.setTimeout(kick, 250);
    root.setTimeout(kick, 1000);
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start);
  else start();
})(typeof window !== 'undefined' ? window : global);
